export const post = [
    {
        content:
            "Community feeds are designed to reflect different topics - they help to communicate more meaningful, important things. You can write posts or comment on somebody else’s - and so can other members of your space. Go on, click on the one that looks interesting!",
        target: "#nav-Feeds",
        placement: "right",
    },
];
